import moment from 'moment';

export const event = () => {
    return {
        id: null,
        event_id: null,
        type_id: null,
        description: '',
        leadership_id: null,
        user_id: null,
        contact_id: null,
        contact_warehouse_id: null,
        address: '',
        telephone: '',
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        repeat_id: null,
        repeat_every: 1,
        repeat_on: [],
        end_id: 1,
        repeat_until: moment().add(1, 'month').format('YYYY-MM-DD'),
        repeat_count: null,
        observations: '',
        attachments: [],
        attachments_loaded: [],
        edit_mode: 'event',
        //
        startTime: null,
        endTime: null,
        user_creator_id: null,
        user_last_modified_id: null,
        user_creator: {},
        user_last_modified: {},
        visit_customer_id: null,
        visit_customer: null,
        attended: false,
        attended_date: null,
        attended_time: null
    };
};

export const timePickerOptionsStart = () => {
    return {
        start: '06:00',
        step: '00:30',
        end: '17:30'
    };
};

export const timePickerOptionsEnd = () => {
    return {
        start: '06:30',
        step: '00:30',
        end: '18:00'
    };
};
export default {
    contacts_warehouses: [],
    contacts: [],
    leaderships: [],
    users: [],
    user: {},
    coordinates: {
        value: null,
        user: null,
    },
    modal: {
        show: false
    },
    would_you_just_run: {
        value: false
    },
    modal_advanced: {
        show: false
    },
    params: {
        paginate: false,
        seller_id: null
    },
    events: [],
    holidays: [],
    events_day: [],
    event: event(),
    action: 'Crear',
    disabled_observation: false,
    loading_editor: false,
    time_picker_options_start: timePickerOptionsStart(),
    time_picker_options_end: timePickerOptionsEnd(),
    parameters: {
        start_date: moment().startOf('month'),
        end_date: moment().endOf('month'),
        leadership_id: null,
        user_id: null,
        would_you_just_run: false
    },
    edit_mode: 'all',
    allow_close: false,
    title_distance: 'Dist.',
    types: [
        {
            id: 1,
            code: '(VI)',
            text: 'Visita',
            icon: 'briefcase'
        },
        {
            id: 2,
            code: '(LL)',
            text: 'Llamada',
            icon: 'phone'
        },
        {
            id: 3,
            code: '(EV)',
            text: 'Evento',
            icon: 'clock-o'
        },
        {
            id: 4,
            code: '(RC)',
            text: 'Reunión comercial',
            icon: 'users'
        },
        {
            id: 5,
            code: '(TC)',
            text: 'Trabajo en casa',
            icon: 'home'
        },
        {
            id: 6,
            code: '(AA)',
            text: 'Ausencia autorizada',
            icon: 'handshake-o'
        },
        {
            id: 7,
            code: '(RG)',
            text: 'Registro gastos Correrías',
            icon: 'cloud-upload'
        },
        {
            id: 8,
            code: '(CO)',
            text: 'Cobranza',
            icon: 'money'
        }
    ]
};



// WEBPACK FOOTER //
// ./src/modules/schedule/state.js